export const ZENDESK_CHECK_INTERVAL = 1000;
export const ZENDESK_CHECK_LIMIT = 60 * 1000; // timeout after one minute
export const CANCEL_CHAT_TAG = 'Cancel Chat';
export const SUPPORT_CHAT_TAG = 'Support Chat';

export const SUPPORT_CHAT_BLACKLIST = ['/settings/membership/update/cancel', '/video'];
